import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatMomentDateModule, MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS, MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { FuseModule } from '@fuse/fuse.module';
import { fuseConfig } from 'app/fuse-config';

import { AppComponent } from 'app/app.component';
import { LayoutModule } from 'app/layout/layout.module';

// Rutas

// Componentes
import { NopagefoundComponent } from './shared/nopagefound/nopagefound.component';

// Modulos
import { MAT_DATE_LOCALE } from '@angular/material/core';  
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatStepperModule } from '@angular/material/stepper';


import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialogRef } from '@angular/material/dialog';
import { InterceptorHelperService } from './services/helpers/interceptor-helper.service';
import { PaginatorEspaniol } from './shared/helpers/helper-paginador-espanol';
import { EssRedirectGuard } from './services/guards/ess-redirect.guard';

const appRoutes: Routes = [
    {
        path: 'login',
        loadChildren: () => import('app/login/login/login.module').then(mod => mod.LoginModule)
    },
    {
        path: 'register/:parametro',
        loadChildren: () => import('app/login/register/register.module').then(mod => mod.RegisterModule)
    },
    // Enlaces antiguos /ess/... → misma ruta sin /ess
    {
        path: 'ess',
        children: [{ path: '**', canActivate: [EssRedirectGuard], children: [] }]
    },
    { path: '', pathMatch: 'full', redirectTo: 'login' },
    {
        path: '',
        loadChildren: () => import('app/main/ess.module').then(mod => mod.EssModule),
    },
    { path: '**', loadChildren: () => import('app/login/login/login.module').then(mod => mod.LoginModule) },

];

@NgModule({
    declarations: [
        AppComponent,
        NopagefoundComponent,
    ],
    imports: [
        RouterModule.forRoot(appRoutes),
        ReactiveFormsModule,
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        //TranslateModule.forRoot(),

        // Material moment date module
        MatMomentDateModule,
        MatStepperModule,

        // Material
        MatButtonModule,
        MatIconModule,

        LayoutModule,
        FuseModule.forRoot(fuseConfig),

        // APP_ROUTES
    ],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
        { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        {
            provide: MatDialogRef,
            useValue: {}
        },
        { provide: HTTP_INTERCEPTORS, useClass: InterceptorHelperService, multi: true},
        { provide: MatPaginatorIntl, useClass: PaginatorEspaniol}
    ],
    bootstrap: [
        AppComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
}
